import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {NewsService} from '@iw-shop/news/services/news.service';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {ApiNews} from "@api/news";
import {isPlatformBrowser} from "@angular/common";
import {deleteReadNews, setReadNews} from "@store/actions/storage.action";

@Component({
    selector: 'iw-shop-news-modal',
    standalone: false,
    templateUrl: './news-modal.component.html',
    styleUrls: ['./news-modal.component.scss']
})
export class NewsModalComponent implements OnInit, OnDestroy {

    destroy$: Subject<boolean> = new Subject<boolean>();
    private readonly isBrowser: boolean;
    news: Pick<ApiNews, 'id' | 'displayOptions' | 'priceGroups'>[] = [];
    readNews: string[] = [];
    readNewsStorage: string[] = [];
    unreadNews: Pick<ApiNews, 'id' | 'displayOptions' | 'priceGroups'>[] = [];

    constructor(private store: Store<AppState>, private newsService: NewsService, @Inject(PLATFORM_ID) platformId: Object,) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.loadNews();
        }

        this.store.select(state => state.storage.readNews)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                r => {
                    r.map(id => {
                        if (!this.readNews.includes(id)) {
                            this.readNewsStorage.push(id);
                        }
                    });
                    this.updateUnreadNews();
                }
            );
    }

    setReadNews(id: string) {
        const news = this.news.filter(n => n.id == id)[0];
        if (news &&
            news.displayOptions?.includes('popup')) {
            this.store.dispatch(setReadNews({id}))
        } else {
            this.readNews.push(id);
            this.updateUnreadNews();
        }

    }

    updateUnreadNews(priceGroup?: string) {

        this.unreadNews = [];
        this.news.map(
            n => {
                if (n.priceGroups &&
                    n.priceGroups.length > 0 &&
                    !n.priceGroups.includes(priceGroup || '')) {
                    return;
                }

                if (
                    n.displayOptions &&
                    n.displayOptions.includes('popupWithoutReadOption') &&
                    !this.readNews.includes(n.id)
                ) {
                    this.unreadNews.push(n);
                    return;
                }


                if (
                    !this.readNews.includes(n.id) &&
                    !this.readNewsStorage.includes(n.id)
                ) {
                    this.unreadNews.push(n);
                    return;
                }
            }
        )
    }

    deleteReadNews() {
        let ids: string[] = [];
        this.news.map(n => {
            ids.push(n.id)
        });

        this.store.dispatch(deleteReadNews({withoutIds: ids}));
    }

    loadNews() {
        this.newsService.get({news: {expectedData: {id: 1, displayOptions: 1, priceGroups: 1}}}).subscribe(
            r => {
                this.news = [];
                if (r.result?.news.data) {
                    r.result.news.data.map(
                        n => {
                            this.news.push({id: n.id, displayOptions: n.displayOptions, priceGroups: n.priceGroups});
                        }
                    )
                    this.deleteReadNews();
                }

            }
        );
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
